<div [ngClass]="{ 'max-w-screen-3xl mx-auto p-3': !fullWidth, 'flex flex-col': fullHeight }" class="bg-white shadow-lg min-h-full">
  @if (pageTitle) {
    <header class="text-center mx-auto my-1 lg:my-2">
      <h1>{{ pageTitle }}</h1>
      @if (subtitle) {
        <p class="text-lg lg:text-xl">{{ subtitle }}</p>
      }
    </header>
  }
  <main [ngClass]="{ 'flex-1 overflow-auto': fullHeight }">
    <ng-content></ng-content>
  </main>
</div>
